import React, { useEffect, useState } from "react";
import Axios from "axios";
// import PageHeaderTitle from "../../componenets/main/pageTitle";
import "../../assets/css/promotion/notice.css";
import Pagination from "../../componenets/post/pagination";
import NoticePostList from "../../componenets/post/noticePostList";
import PageHeaderBackground from "../../componenets/main/pageTitleBackground";
import background from "../../assets/images/notice-background.png";

export default function Notice() {
    const [posts, setPosts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage, setPostsPerPage] = useState(10);
    const [hide, setHide] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            Axios.get("http://211.214.247.21:8000/notice/getNoticeList").then((respones) => {
                setPosts(respones.data.reverse());
            });
        };
        fetchData();
    }, []);

    const indexOfLast = currentPage * postsPerPage;
    const indexOfFirst = indexOfLast - postsPerPage;
    const currentPosts = (posts) => {
        let currentPosts = 0;
        currentPosts = posts.slice(indexOfFirst, indexOfLast);
        return currentPosts;
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            <PageHeaderBackground title="공지사항" sub={hide} background={background} subTitle="broanex" etc="브로넥스에서 전하는 새로운 소식을 확인해보세요." />
            {/* 게시물 */}
            <section className="contents_container_layout">
                <div className="contents_inner_container_layout">
                    {posts.length > 0 ? (
                        <>
                            <NoticePostList idNumber="번호" titleName="제목" titleData="날짜" data={currentPosts(posts)} />
                            <div className="page_item">
                                <Pagination postsPerPage={postsPerPage} totalPosts={posts.length} currentPage={currentPage} onPageChange={handlePageChange} />
                            </div>
                        </>
                    ) : (
                        <div style={{ textAlign: 'center', padding: '100px 20px', color: '#666' }}>
                            <p style={{ fontSize: '18px', marginBottom: '10px' }}>등록된 공지사항이 없습니다.</p>
                            <p style={{ fontSize: '14px', color: '#999' }}>새로운 소식이 등록되면 알려드리겠습니다.</p>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}
